import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import { rootSaga } from './rootSaga';
import createRootReducer from './rootReducer';
import { persistConfig } from './persistConfig';

// ==============================================================
const persistedReducer = persistReducer(persistConfig, createRootReducer());

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
	reducer: persistedReducer,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			serializableCheck: false,
		}).concat(sagaMiddleware),
	devTools: true,
	preloadedState: {},
});

const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export { store, persistor };
